import { render, staticRenderFns } from "./CatalogRegister.vue?vue&type=template&id=52fa83c8&scoped=true&"
import script from "./CatalogRegister.vue?vue&type=script&lang=ts&"
export * from "./CatalogRegister.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogRegister.vue?vue&type=style&index=0&id=52fa83c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa83c8",
  null
  
)

export default component.exports